import { DeviceInfo, DeviceKind, ScreenCategory } from './types';

/* Small dependency-free user-agent parser. Only claims what it can verify. */

export function detectDevice(ua: string): DeviceKind {
  const u = ua.toLowerCase();
  const isTablet =
    /ipad|tablet|tab|sm-t|gt-p|kfapowi|kindle/i.test(u) ||
    (/android/i.test(u) && !/mobile/i.test(u) && window.innerWidth >= 768);
  if (isTablet) return 'tablet';
  const isMobile = /mobile|android|iphone|ipod|opera mini|blackberry|windows phone/i.test(u);
  return isMobile ? 'mobile' : 'desktop';
}

export function parseBrowser(ua: string): string {
  const u = ua.toLowerCase();
  if (/edg\//.test(u)) return 'Edge';
  if (/opr\/|opera/.test(u)) return 'Opera';
  if (/samsungbrowser/.test(u)) return 'Samsung Internet';
  if (/chrome|crios/.test(u)) return 'Chrome';
  if (/firefox|fxios/.test(u)) return 'Firefox';
  if (/safari/.test(u)) return 'Safari';
  if (/msie|trident/.test(u)) return 'Internet Explorer';
  return 'Other';
}

export function parseOs(ua: string): string {
  const u = ua.toLowerCase();
  if (/windows nt/.test(u)) return 'Windows';
  if (/iphone|ipad|ipod/.test(u)) return 'iOS';
  if (/android/.test(u)) return 'Android';
  if (/mac os x|macintosh/.test(u)) return 'macOS';
  if (/linux|ubuntu|fedora|arch/.test(u)) return 'Linux';
  if (/crkey|sm_t|chromeos/.test(u)) return 'Chrome OS';
  return 'Other';
}

export function detectScreen(): ScreenCategory {
  if (typeof window === 'undefined') return 'md';
  const w = window.screen.width || window.innerWidth || 0;
  if (w < 480) return 'xs';
  if (w < 768) return 'sm';
  if (w < 1280) return 'md';
  if (w < 1920) return 'lg';
  return 'xl';
}

export function getDeviceInfo(): DeviceInfo {
  const ua = navigator.userAgent || '';
  const device = detectDevice(ua);
  return {
    device,
    browser: parseBrowser(ua),
    os: parseOs(ua),
    screen: detectScreen(),
  };
}